import { LocalShipping, Security, SupportAgent } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// Feature highlight component for the top section
function FeatureHighlight({
  icon: Icon,
  title,
  description,
}: {
  icon: any;
  title: string;
  description: string;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box
        sx={{
          p: 1.5,
          borderRadius: 1.5,
          backgroundColor: "#F7A81B", // Using website orange color
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease-in-out",
        }}
      >
        <Icon fontSize="small" />
      </Box>
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight={600}
          color="white"
          className="notranslate"
          translate="no"
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="rgba(255, 255, 255, 0.8)"
          className="notranslate"
          translate="no"
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

export default function TopFooter() {
  const { t: myTranslate } = useTranslation();

  const features = [
    {
      icon: LocalShipping,
      title: myTranslate("footer.features.fastShipping"),
      description: myTranslate("footer.features.fastShippingDesc"),
    },
    {
      icon: Security,
      title: myTranslate("footer.features.fairPricing"),
      description: myTranslate("footer.features.fairPricingDesc"),
    },
    {
      icon: SupportAgent,
      title: myTranslate("footer.features.easyReturns"),
      description: myTranslate("footer.features.easyReturnsDesc"),
    },
  ];

  return (
    <Box
      sx={{
        // Desktop: Container with padding and margins
        // Mobile: Simple box that fits within parent Grid
        maxWidth: { xs: "100%", md: "xl" },
        mx: { xs: 0, md: "auto" },
        px: { xs: 0, md: 3 },
        pt: { xs: 0, md: 6 },
        pb: { xs: 0, md: 4 },
      }}
    >
      <Grid container spacing={{ xs: 1, md: 2 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} md={4} key={index}>
            <FeatureHighlight
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
